import { useCallback, useMemo } from 'react'
import { generateClient } from 'aws-amplify/api'

import { getTargets } from '../graphql/queries'

export const useTarget = () => {
  const client = useMemo(() => generateClient(), [])
  const fetchTargets = useCallback(
    async (offeringId) => {
      return client.graphql({
        query: getTargets,
        variables: { offeringId },
      })
    },
    [client],
  )

  return {
    fetchTargets,
  }
}
